var map = {
	"./mobile/tdsEngland.png": "./src/components/tds/mobile/tdsEngland.png",
	"./tab/tdsEngland.png": "./src/components/tds/tab/tdsEngland.png",
	"./web/tdsEngland.png": "./src/components/tds/web/tdsEngland.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/components/tds sync recursive ^.*tdsEngland\\.png$";